import * as z from "zod";

export const deleteEcwidIntegration = {
  name: "deleteEcwidIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
